<template>
    <auth-layout>
        <div class="w-full md:w-1/2 flex flex-col">
            <div class="flex flex-col justify-center md:justify-start my-auto pt-8 md:pt-0 px-8 md:px-24 lg:px-32">
                <span class="text-center text-5xl md:text-2xl lg:text-4xl xl:text-6xl font-bold" data-cy="form-header">
                    <template v-if="isEpicvaultEnabled">
                        <img
                            class="inline-block h-12 md:h-6 lg:h-8 xl:h-12"
                            :src="'/images/icon-epic-vault.png'"
                            alt="logo"
                        />
                        <span class="text-black align-bottom">Epic</span
                        ><span class="text-default-blue align-bottom">Vault</span>
                    </template>
                    <template v-else>
                        <img class="inline-block h-12 md:h-6 lg:h-8 xl:h-12" :src="'/images/icon.png'" alt="logo" />
                        <span class="text-black align-bottom">Claims</span
                        ><span class="text-default-purple align-bottom">Vault</span>
                    </template>
                </span>

                <form-login
                    :login="login"
                    :validation="validation"
                    :processing="processing"
                    :theme="getTheme"
                    @formSubmit="handleSubmit"
                >
                </form-login>

                <div class="text-center pt-12 pb-12">
                    <p>
                        <router-link :to="{ name: 'forgot_password' }" class="underline" data-cy="forgot_password_link">
                            {{ $t('auth.links.forgot_password') }}
                        </router-link>
                    </p>
                </div>
            </div>
        </div>
    </auth-layout>
</template>

<script>
import AuthLayout from '@/layouts/AuthLayout.vue';
import FormLogin from '@/components/forms/auth/Login.vue';

export default {
    components: {
        AuthLayout,
        FormLogin,
    },
    data() {
        return {
            login: {
                email: '',
                password: '',
                remember: false,
            },
            validation: {
                errors: {},
                message: '',
            },
            processing: false,
        };
    },
    computed: {
        isEpicvaultEnabled() {
            return this.$store.state.system.is_epicvault_enabled;
        },
        getTheme() {
            return this.isEpicvaultEnabled ? 'default' : 'claimsvault';
        },
    },
    methods: {
        handleSubmit() {
            this.processing = true;
            this.validation = '';

            this.$http
                .post('/api/login', this.login)
                .then(() => {
                    this.$router.go('/login');
                })
                .catch((error) => {
                    if (error.response.status == 422) {
                        this.validation = error.response.data;
                    } else if (error.response.status == 419) {
                        // if the user stays on the login page for too long the csrf token gets invalid and returns a 419 error code.
                        // reload page so that it can resolve itself.
                        this.$router.go('/login');
                    } else {
                        this.$notification.error({
                            message: this.$t('globals.global.notifications.error.any', { code: 'CVLI01' }),
                        });
                    }

                    this.processing = false;
                });
        },
    },
};
</script>
